<template>
  <v-card>
    <ac-data-table
      :headers="headers"
      :items="items"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="name"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Addon Units"
    >
      <template #actions>
        <v-menu
          :absolute="false"
          :close-on-click="true"
          :close-on-content-click="true"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="ma-2" color="primary">
              ADD
              <v-icon class="ml-2" small>mdi-text-box</v-icon>
            </v-btn>
          </template>
          <v-sheet max-height="600">
            <v-list dense class="pa-0">
              <v-list-item
                v-for="(type,i) in types"
                :key="type+i"
                dense
                @click="row_create(type)"
              >
                <v-list-item-title v-text="type.name"/>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>


      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.group="{item}">
        <div align="center">{{ getAddonGroupName(item) }}</div>
      </template>
      <template v-slot:item.remoteAssets="{item}">
        <div align="center">{{ item.remoteAssets ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_convert(item)" class="mr-2" small color="blue">mdi-cloud-upload-outline</v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-map-addon-island-dialog ref="dialog_1"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {MapAddonType} from "@/modules/redactor/models/map-addon/core/MapAddonType";
import {MapAddonModel} from "@/modules/redactor/models/map-addon/core/MapAddonModel";

import RMapAddonIslandDialog from "@/modules/redactor/views/map-addon/addon/v-map-addon-island-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  components: {RDialogPreviewCollection, AcDataTable, RMapAddonIslandDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Name", value: "name"},
      {text: "Type", value: "type.name"},
      {text: "Group", value: "group"},
      {text: "Remote Assets", value: "remoteAssets"},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(MapAddonModel)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    },
    types() {
      return MapAddonType.getValues();
    },
  },
  methods: {
    row_view(item) {
      this.$refs['dialog_' + item.type.id].show(ViewRules.READONLY, item.clone())
          .catch(() => {

          });
    },
    row_copy(item) {
      this.$refs['dialog_' + item.type.id].show(ViewRules.COPY, item.copy()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushMapAddon(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_create(type) {
      this.$refs['dialog_' + type.id].show(ViewRules.CREATE, null).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushMapAddon(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog_' + item.type.id].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushMapAddon(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeMapAddon(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkMapAddons(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushMapAddon(result);
    },
    row_convert(item) {
      this.$confirm("Are you sure you want to move this item to global config?")
          .then(() => {
            RedactorUtils.convertMapAddon(item.clone())
                .then(() => {
                  this.$alert("Changes was published", "Convert To Global", "success");
                })
                .catch((error) => {
                  this.$alert(error, "Convert To Global", "error");
                });
          });
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_duplicate(item) {
      return this.items.find(v => {
        return v.key === item.key && v.uid !== item.uid;
      });
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },

    getAddonGroupName(item) {
        const group = RedactorUtils.getMapAddonGroup(item.group);
        return group ? group.name : "unknown";
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, MapAddonModel, "map-addon")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getMapAddons();
  }
};
</script>